export const ACTION_TYPES = {
  UPDATE_CUSTOMER: 'customer/UPDATE_CUSTOMER'
};
